<ng-container *transloco="let t">
  <h2 mat-dialog-title>{{ data.label }}</h2>

  <mat-dialog-content class="overflow-hidden!">
    <div class="search-input-wrapper mb-3">
      <i class="iconify size-4.5! opacity-80" data-icon="mdi-light:magnify"></i>
      <input [(ngModel)]="searchTerm" (ngModelChange)="search()" autocomplete="off" [placeholder]="t('Search')" />
    </div>

    @if (!loading()) {
    <div class="text-xs text-muted-foreground px-4">
      {{ results.length }} {{ t('of') }} {{ count }}
    </div>
    }

    @if (loading()) {
    <div class="flex justify-center py-6">
      <mat-spinner [diameter]="28"></mat-spinner>
    </div>
    } @else {

    <div class="flex   items-center border-b border-border gap-2 py-2 pl-4 cursor-pointer " (click)="toggleAllVisible()">
        <span class="text-sm font-medium flex-1">{{ t('Select all') }}</span>
        <mat-checkbox class="pointer-events-none" [checked]="allVisibleSelected" ></mat-checkbox>
    </div>

    <ng-scrollbar class="max-h-96!" visibility="hover" appearance="compact">
      @for (item of results; track item.id ?? item.code) {
      <div
        class="flex items-center gap-2 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors rounded-xl cursor-pointer"
        (click)="toggle(item)">
        @if(item.color) {
        <div class="rounded-full w-1 h-6 mx-4 opacity-70" [style.background-color]="item.color"> </div>
        }

        <div class="flex flex-col flex-1 ml-4">
          <span class="text-sm">{{ item.name }}</span>
          @if(item.note) {
          <span class="text-xs opacity-80 ">{{ item.note }}</span>
          }
        </div>
        <mat-checkbox [checked]="!!item.selected" class="pointer-events-none"></mat-checkbox>
      </div>
      }
    </ng-scrollbar>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="cancel()">{{ t('Cancel') }}</button>
    <button mat-flat-button color="primary" (click)="confirm()">{{ t('Confirm') }}</button>
  </mat-dialog-actions>
</ng-container>
